module.exports = __webpack_public_path__ + "141d4a85/img/note-list-icon.961c1485.svg";